// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 2H22V22H13V16H11V22H2V2H9V7H15V2ZM4 20H7V4H4V20ZM17 4V20H20V4H17ZM14 11H10V13H14V11Z"}}]};

const City3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-3-filled',
    ref,
    icon: element,
  },
));

City3FilledIcon.displayName = 'City3FilledIcon';

export default City3FilledIcon;
